import React from "react";
import "./style.css";
import { MdLibraryAdd } from "react-icons/md";
import SpecialOffers from "../../components/Products/special-offers";
import Products from "../../components/Products";
import { connect } from "react-redux";
import Banner from "./banner";
import { List, ListItem } from "./Widgets";

const Body = ({ addToCart, addToWish }) => {
    return (
        <div>
            <MdLibraryAdd className="icons add-post-btn ripple-always" />
            <Banner />
            <SpecialOffers />
            <div className="split-section">
                <div className="split-main">
                    <Products 
                        heading="Featured Products"
                        addToCart={ addToCart }
                        addToWish={ addToWish } />
                </div>
                <div className="split-aside">
                    <div className="categories">
                        <div className="section">
                            <h3>Best Sellers</h3>
                            <List>
                                <ListItem text="green travel bag" secondary="$53.09" />
                                <ListItem text="ps5 game pad" secondary="$104.09" />
                                <ListItem text="xbox console" secondary="$343.09" />
                                <ListItem text="men's suit black" secondary="$420.09" />
                                <ListItem text="sketcher wears" secondary="$73.09" />
                                <ListItem text="rayban watch" secondary="$653.09" />
                                <ListItem text="women's sunglasses" secondary="$33.09" />
                            </List>
                        </div>

                        <div className="section">
                            <h3>Categories</h3>
                            <List>
                                <ListItem text="bags" />
                                <ListItem text="men's" />
                                <ListItem text="shoes" />
                                <ListItem text="tops" />
                                <ListItem text="suits" />
                                <ListItem text="watches" />
                                <ListItem text="women's" />
                            </List>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const matchStateToProps = (state) => {
    return {
      basket: state.basket
    }
}

const matchDispatchToProps = (dispatch) => {
    return{
        addToCart: (item) => dispatch({ type: "ADD_TO_CART", item }),
        addToWish: (item) => dispatch({ type: "ADD_TO_WISH", item })
    }
}

export default connect(matchStateToProps, matchDispatchToProps)(Body);